import { Stores, FooterMenus } from "components/Constants";
import React from "react";
import styled from "styled-components/macro";
import { Desktop, device, toRem } from "theme/Breakpoints";
import { Container } from "theme/GlobalElements";
import { colors } from "theme/Theme";
import AddressSection from "./AddressSection";
import MenuSection from "./MenuSection";
import SocialSection from "./SocialSection";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsFooterVisible } from "./footerSlice";

const Footer = () => {
  var d = new Date();
  var n = d.getFullYear();
  const location = useLocation();
  const isVisible = useSelector(selectIsFooterVisible);

  const isSitemap = location.pathname?.includes("sitemap");
  const isLogin = location.pathname?.includes("asparuh");
  if (isSitemap || isLogin) return null;

  return isVisible ? (
    <FooterContainer>
      <TopSection></TopSection>
      <Wrapper>
        {FooterMenus.map((data, idx) => {
          return <MenuSection key={idx} data={data} />;
        })}

        {Stores.map((store, idx) => {
          return <AddressSection key={idx} store={store} />;
        })}
        <SocialSection />
      </Wrapper>
      <BottomSection>
        <BottomWrapper>
          <Desktop>
            <Logo src="/logo_mobile.png" />
          </Desktop>
          <Text className="text-body">{`Copyright ${n}| I-Clima © | Designs by Twentyone team`}</Text>
        </BottomWrapper>
      </BottomSection>
    </FooterContainer>
  ) : (
    <></>
  );
};

const FooterContainer = styled.div`
  display: flex;
  height: auto;
  width: 100%;
  background-image: url("/pattern-header.svg");
  flex-direction: column;

  justify-content: space-between;
  align-items: center;
`;
const Wrapper = styled(Container)`
  width: 100%;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media only screen and (${device.laptop}) {
    flex-direction: row;

    align-items: flex-start;
    display: inline-flex;
  }
`;

const TopSection = styled.div`
  display: inline-flex;
  height: 50px;
  width: 100%;
  background-color: ${colors.dark_gray};
`;

const BottomSection = styled.div`
  display: inline-flex;
  height: 50px;
  width: 100%;
  background-color: black;
`;
const Logo = styled.img`
  @media only screen and (${device.laptop}) {
    width: ${toRem(80)};
    height: auto;
  }
`;
const BottomWrapper = styled(Wrapper)`
  padding: 0 10px;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media only screen and (${device.laptop}) {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;
const Text = styled.span`
  color: white;
  font-weight: 600;
`;
export default Footer;
